import { APP_BASE_HREF } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { slashJoin } from 'path-slashes';
import { Observable, of } from 'rxjs';

import { WINDOW } from 'src/app/utils/window.token';

import { NbaParamResolver } from '../nba-param-resolver.interface';

import { NbaParamResolverId } from './nba-param-resolver-id.enum';

@Injectable()
export class LocationOriginAndBaseHrefResolver implements NbaParamResolver {
  public readonly identifier: string = NbaParamResolverId.LocationOriginAndBaseHref;

  public constructor(
    @Inject(APP_BASE_HREF) private readonly baseHref: string,
    @Inject(WINDOW) private readonly window: Window
  ) {}

  public resolve$(): Observable<string> {
    return of(slashJoin(this.window.location.origin, this.baseHref));
  }
}
